module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tzzjy"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 0 && Math.floor(_vm.ChoseTab / 4) === 0) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 1 && Math.floor(_vm.ChoseTab / 4) === 1) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 2 && Math.floor(_vm.ChoseTab / 4) === 2) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showOthers),
      expression: "!showOthers"
    }],
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.showOthers = true
      }
    }
  }, [_c('i', {
    staticClass: "am-icon-chevron-down"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOthers),
      expression: "showOthers"
    }],
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.showOthers = false
      }
    }
  }, [_c('i', {
    staticClass: "am-icon-chevron-up"
  })])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOthers),
      expression: "showOthers"
    }],
    staticClass: "tab"
  }, [_vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 1 && Math.floor(_vm.ChoseTab / 4) !== 1) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 0 && Math.floor(_vm.ChoseTab / 4) === 1) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOthers),
      expression: "showOthers"
    }],
    staticClass: "tab"
  }, [_vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 2 && Math.floor(_vm.ChoseTab / 4) !== 2) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.title), function(item, key, index) {
    return (Math.floor(index / 4) === 0 && Math.floor(_vm.ChoseTab / 4) === 2) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'tzzjy',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('List', {
    staticClass: "min-height",
    attrs: {
      "list": _vm.list,
      "name": _vm.$route.params.nr
    }
  }), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("投资者教育")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-804fe2e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/tzzjy/tzzjy.vue
// module id = 902
// module chunks = 2